import { IoIosMore } from "react-icons/io";
import { ClassNames } from '../../utils/ClassNames';
import { useDispatch } from 'react-redux';
import { fetchCustomers } from "../../redux/slices/CustomerSlice";
import { useEffect } from "react";
import Loader from "../Loader";
import ResponsivePagination from 'react-responsive-pagination';
import { FormattedText } from "../../utils/FormattedData";


const CustomersTable = ({ onRowClick, data, itemsPerPage, currentPage, setCurrentPage, isLoading, totalRecord }) => {
  const dispatch = useDispatch()

  const totalPages = Math.ceil(totalRecord / itemsPerPage);
  
  useEffect(() =>{
      dispatch(fetchCustomers())
  }, [dispatch]);
  

  // const handleAdd = (item) => {
  //   setSelected(item);
  //   setIsopen(true);
  // };
  // const handleEdit = async (item) => {
  //   setSelected(item)
  // };
  // const handleDeactivate = async (item) => {
  //   setSelected(item)
  // };

  return (
    <div className="flow-rot bg-white">
      <div className="overflow-x-auto sm:-px-6 lg:-px-8 rounded-lg border border-primaryGray">
        <div className="inline-block min-w-full align-middle">
          <table className="min-w-full divide-y divide-gray-300 table-auto px-3">
            <thead className="bg-primaryGray">
              <tr>
                <th scope="col" className="whitespace-nowrap py-3.5 pl-3 text-left text-sm font-bold text-gray-900">
                  S/N
                </th>
                <th scope="col" className="whitespace-nowrap py-3.5  pl-3 text-left text-sm font-bold capitalize text-gray-900">
                  customer name
                </th>
                <th scope="col" className="px-3 whitespace-nowrap py-3.5 text-left text-sm font-bold capitalize text-gray-900">
                phone number
                </th>
                <th scope="col" className="px-3 whitespace-nowrap py-3.5 text-sm text-left font-bold capitalize text-gray-900">
                email
                </th>
                <th scope="col" className="px-3 whitespace-nowrap py-3.5 text-left text-sm font-bold capitalize text-gray-900">
                  gender
                </th>
                <th scope="col" className="px-3 whitespace-nowrap py-3.5 text-left text-sm font-bold capitalize text-gray-900">
                  favourite categories
                </th>
                <th scope="col" className="px-3 whitespace-nowrap py-3.5 text-center text-sm font-bold capitalize text-gray-900">
                  Action
                </th>
              </tr>
            </thead>
            <tbody>
            {isLoading ? (
              <Loader />
            ): data && data.length > 0 ? (
              <>
                  { data.map((customer, index) =>(
                  <tr key={index} className="border-b border-b-primaryGray cursor-pointer hover:bg-[#F9F9F9]" onClick={() => onRowClick(customer.id)}>
                    <td className="whitespace-nowrap px-3 white-space-nowrap py-4 text-sm text-black capitalize">{`${index + 1}`}</td>
                    <div className="flex items-center pt-4">
                      <img src={customer.photo} alt="" className="rounded-full h-6 w-6" />
                      <td className="whitespace px-3 text-sm capitalize font-semibold">{customer.firstName} <span className="ml-1">{customer.lastName}</span></td>
                    </div>
                    <td className="whitespace-nowrap px-3 text-sm italic capitalize font-semibold text-[#0A0A0A]/80">
                      {customer.phoneNumber}
                    </td>
                    <td className="whitespace-nowrap px-3 text-sm text-[#0A0A0A]/80">
                    {customer.email}
                    </td>
                    <td className={`${ClassNames(customer.gender === "Male" ? "bg-[#4A90E2] text-white" : customer.gender === "Female" ? "bg-orange text-black": "bg-primaryGray")} rounded-m inline-block w-2/3 text-center whitespace-nowrap px-2 py-2 mb-2 rounded-md text-sm text-black capitalize`}>
                    <span className="">
                        {customer?.gender || "Nil"}
                      </span>
                      </td>
                    <td className="whitespace-nowrap px-3 text-sm capitalize font-semibold text-[#0A0A0A]/80">{FormattedText(customer.favoriteCategories) }</td>
                    <td className="whitespace-nowrap px-3 text-lg text-[#B3B3B3] flex items-center justify-center">{<IoIosMore />}</td>
                  </tr>
                ))}
              </>
            ): (
              <p className="text-sm text-primaryRed text-center py-4">No Customer available</p>
            )}
            </tbody>
          </table>
        </div>
      </div>
      <nav className="grid place-items-center mt-10">
        <ResponsivePagination
          current={currentPage}
          total={totalPages}
          onPageChange={setCurrentPage}
          extraClassName="custom-pagination"
          />
      </nav>
    </div>
  );
};

export default CustomersTable;
